import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news1 from "../../images/news/news_11_1.jpg";
import news2 from "../../images/news/news_11_2.jpg";

import { withTranslation } from "react-i18next";


class news10 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News11_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News11_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News11_LinkHome")}</Link>
								</li>
								<li>{t("News11_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News11_Content_H")}</h1>
											<p>{t("News11_Content_P1")}</p>
											<p1>{t("News11_Content_P2")}</p1>
											<p>{t("News11_Content_P3")}</p>
											<img src={news1} alt="" />
											<hr />
											<p>{t("News11_Content_P4")}</p>
											<p>{t("News11_Content_P5")}</p>
											<img src={news2} alt="" />
											<hr />
											<p>{t("News11_Content_P6")}</p>
											<p>{t("News11_Content_P7")}</p>
											<p>{t("News11_Content_P8")}</p>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news10 = withTranslation()(news10);
